import script from "./AuthenticationDialogTest.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthenticationDialogTest.vue?vue&type=script&lang=ts&setup=true"

import "./AuthenticationDialogTest.vue?vue&type=style&index=0&id=2f453c32&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f453c32"]])

export default __exports__